import { Component, Input, ViewChild } from '@angular/core';
import { MatExpansionModule, MatExpansionPanel } from '@angular/material/expansion';

@Component({
  selector: 'app-info-panel-expansion-section',
  standalone: true,
  imports: [MatExpansionModule],
  templateUrl: './info-panel-expansion-section.component.html',
  styleUrl: './info-panel-expansion-section.component.css',
})
export class InfoPanelExpansionSectionComponent {
  @Input({ required: true }) title!: string;
  @Input() columns = 2;
  @Input() expanded = true;

  @ViewChild(MatExpansionPanel) private panel!: MatExpansionPanel;

  get gridColumns(): string {
    return `repeat(${this.columns}, 1fr)`;
  }

  reset(): void {
    this.expanded ? this.panel.open() : this.panel.close();
  }
}
